import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shared axios instance for all backend calls.
export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});
